import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M23 12.2168C23 18.2919 18.0751 23.2168 12 23.2168C5.92487 23.2168 1 18.2919 1 12.2168C1 6.14166 5.92487 1.2168 12 1.2168C18.0751 1.2168 23 6.14166 23 12.2168ZM13 8.2168V6.2168H11V8.2168H13ZM13 9.2168H11V17.2168H13V9.2168Z",
		fill: "#395566"
	})
});
export default SvgFill;
